import axios from "api/axios";
import useAuthContext from "contexts/Auth/useAuthContext";
import {FC, useEffect, useRef} from "react";

const OAuthAuthorize: FC = () => {
  const auth = useAuthContext();
  const processingRef = useRef(false);

  // Save PKCE params from URL into sessionStorage on first render so they
  // survive the login redirect (AuthProvider redirects via window.location).
  useEffect(() => {
    const sp = new URLSearchParams(window.location.search);
    const challenge = sp.get("challenge");
    const redirectUri = sp.get("redirect_uri");
    if (challenge) sessionStorage.setItem("pkce_challenge", challenge);
    if (redirectUri) sessionStorage.setItem("pkce_redirect_uri", redirectUri);
  }, []);

  useEffect(() => {
    if (auth === undefined || processingRef.current) return;

    if (auth === null) {
      // Not logged in — send through normal login, then bounce back here.
      localStorage.setItem("redirect", "/auth/oauth");
      window.location.href = "/auth";
      return;
    }

    const challenge = sessionStorage.getItem("pkce_challenge");
    const redirectUri = sessionStorage.getItem("pkce_redirect_uri");

    if (!challenge || !redirectUri) {
      window.location.href = "/";
      return;
    }

    processingRef.current = true;
    axios
      .post("/auth/requestOAuthPKCECode", {challenge, redirectUri})
      .then(({data}) => {
        sessionStorage.removeItem("pkce_challenge");
        sessionStorage.removeItem("pkce_redirect_uri");
        const url = new URL(redirectUri);
        url.searchParams.set("code", data.code);
        window.location.href = url.toString();
      })
      .catch(() => {
        processingRef.current = false;
      });
  }, [auth]);

  return (
    <div className="w-full h-full flex items-center justify-center">
      <span className="text-slate-500 text-sm">Authorizing...</span>
    </div>
  );
};

export default OAuthAuthorize;
